import { Box, Button, Drawer, List, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import usePageSize from "../../hooks/UsePageSize";
import { getDrawerItemsForSize } from "../../utils/menu";
import DrawerMenuItem from "./DrawerMenuItem";

export default function CustomizedDrawer(props: {
    toggleDrawer: () => void;
    drawerOpen: boolean;
}) {
    const size = usePageSize();
    const drawerItems = getDrawerItemsForSize(size);

    return (
        <Drawer
            anchor={"left"}
            open={props.drawerOpen}
            onClose={props.toggleDrawer}
            sx={{
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: { width: 300, borderRadius: 0 },
            }}
        >
            <List sx={{ flexGrow: 1 }}>
                {drawerItems.map((item) => (
                    <DrawerMenuItem
                        key={item.title}
                        menuItem={item}
                        toggleDrawer={props.toggleDrawer}
                    />
                ))}
                <Box sx={{ p: 2 }}>
                    <Link to="/subscriptions">
                        <Button
                            fullWidth={true}
                            sx={{
                                display: { md: "none", xs: "inline-block" },
                            }}
                            size="small"
                            variant="contained"
                            color="secondary"
                        >
                            مقایسه اشتراک ها
                        </Button>
                    </Link>
                </Box>
            </List>

            <Typography sx={{ width: "100%", textAlign: "center", my: 2 }}>
                پرشین سازه
            </Typography>
        </Drawer>
    );
}
